import { COMMA, ENTER } from '@angular/cdk/keycodes';
import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';

import { riskControlDropdownDto } from 'src/app/core/models/riskControl/riskControl-filter';
import { AssignedRoleDto } from 'src/app/core/models/user-management/assigned-role-model';

@Component({
  selector: 'app-filter-risk-control',
  templateUrl: './filter-risk-control.component.html',
  styleUrls: ['./filter-risk-control.component.scss']
})
export class FilterRiskControlComponent {

  separatorKeysCodes: number[] = [ENTER, COMMA];
  selectable: boolean = true;
  removable: boolean = true;
  filterForm!: FormGroup;

  searchriskrefCntrl: FormControl = new FormControl();
  searchriskAreaCntrl: FormControl = new FormControl();
  searchriskCategoryCntrl: FormControl = new FormControl();
  searchriskTitleCntrl: FormControl = new FormControl();
  searchcomplianceTopicCntrl: FormControl = new FormControl();
  searchentitiesImpactedCntrl: FormControl = new FormControl();
  searchriskOwnerCntrl: FormControl = new FormControl();
  searchriskDescriptionCntrl: FormControl = new FormControl();
  searchapplicableRulesCntrl: FormControl = new FormControl();
  saerchinherentRiskRatingCntrl:FormControl = new FormControl();
  searchresidualRiskRatingCntrl:FormControl=new FormControl();

  @ViewChild('riskRefAutoComplete')
  riskRefAutoComplete!: MatAutocomplete;
  @ViewChild('riskAreaAutoComplete')
  riskAreaAutoComplete!: MatAutocomplete;
  @ViewChild('riskCategoryAutoComplete')
  riskCategoryAutoComplete!: MatAutocomplete;
  @ViewChild('riskTitleAutoComplete')
  riskTitleAutoComplete!: MatAutocomplete;
  @ViewChild('complianceTopicAutoComplete')
  complianceTopicAutoComplete!: MatAutocomplete;
  @ViewChild('entitiesImpactedAutoComplete')
  entitiesImpactedAutoComplete!: MatAutocomplete;
  @ViewChild('riskOwnerAutoComplete')
  riskOwnerAutoComplete!: MatAutocomplete;
  @ViewChild('riskDescriptionAutoComplete')
  riskDescriptionAutoComplete!: MatAutocomplete;
  @ViewChild('applicableRulesAutoComplete')
  applicableRulesAutoComplete!: MatAutocomplete;
  @ViewChild('inherentRiskRatingAutoComplete')
  inherentRiskRatingAutoComplete!:MatAutocomplete;
  @ViewChild('residualRiskRatingAutoComplete')
  residualRiskRatingAutoComplete!:MatAutocomplete;


  @ViewChild('riskRefAutoTrigger')
  riskRefAutoTrigger!: MatAutocompleteTrigger;
  @ViewChild('riskAreaAutoTrigger')
  riskAreaAutoTrigger!: MatAutocompleteTrigger;
  @ViewChild('riskCategoryAutoTrigger')
  riskCategoryAutoTrigger!: MatAutocompleteTrigger;
  @ViewChild('riskTitleAutoTrigger')
  riskTitleAutoTrigger!: MatAutocompleteTrigger;
  @ViewChild('complianceTopicAutoTrigger')
  complianceTopicAutoTrigger!: MatAutocompleteTrigger;
  @ViewChild('entitiesImpactedAutoTrigger')
  entitiesImpactedAutoTrigger!: MatAutocompleteTrigger;
  @ViewChild('riskOwnerAutoTrigger')
  riskOwnerAutoTrigger!: MatAutocompleteTrigger;
  @ViewChild('riskDescriptionAutoTrigger')
  riskDescriptionAutoTrigger!: MatAutocompleteTrigger;
  @ViewChild('applicableRulesAutoTrigger')
  applicableRulesAutoTrigger!: MatAutocompleteTrigger;
  @ViewChild('inherentRiskRatingAutoTrigger')
  inherentRiskRatingAutoTrigger!: MatAutocompleteTrigger;
  @ViewChild('ResidualRiskRatingAutoTrigger')
  ResidualRiskRatingAutoTrigger!: MatAutocompleteTrigger;


  @ViewChild('riskRefInput')
  riskRefInput!: ElementRef<HTMLInputElement>;
  @ViewChild('riskAreaInput')
  riskAreaInput!: ElementRef<HTMLInputElement>;
  @ViewChild('riskCategoryInput')
  riskCategoryInput!: ElementRef<HTMLInputElement>;
  @ViewChild('riskTitleInput')
  riskTitleInput!: ElementRef<HTMLInputElement>;
  @ViewChild('complianceTopicInput')
  complianceTopicInput!: ElementRef<HTMLInputElement>;
  @ViewChild('entitiesImpactedInput')
  entitiesImpactedInput!: ElementRef<HTMLInputElement>;
  @ViewChild('riskOwnerInput')
  riskOwnerInput!: ElementRef<HTMLInputElement>;
  @ViewChild('riskDescriptionInput')
  riskDescriptionInput!: ElementRef<HTMLInputElement>;
  @ViewChild('applicableRulesInput')
  applicableRulesInput!: ElementRef<HTMLInputElement>;
  @ViewChild('inherentRiskRatingInput')
  inherentRiskRatingInput!: ElementRef<HTMLInputElement>;
  @ViewChild('residualRiskRatingInput')
  residualRiskRatingInput!: ElementRef<HTMLInputElement>;



  searchedriskrefList: riskControlDropdownDto[] = [];
  searchedriskAreaList: riskControlDropdownDto[] = [];
  searchedriskCategoryList: riskControlDropdownDto[] = [];
  searchedriskTitleList: riskControlDropdownDto[] = [];
  searchedcomplianceTopicList: riskControlDropdownDto[] = [];
  searchedentitiesImpactedList: riskControlDropdownDto[] = [];
  searchedriskOwnerList: riskControlDropdownDto[] = [];
  searchedriskDescriptionList: riskControlDropdownDto[] = [];
  searchedapplicableRulesList: riskControlDropdownDto[] = [];
  searchedinherentRiskRatingList: riskControlDropdownDto[] = [];
  searchedresidualRiskRatingList: riskControlDropdownDto[] = [];
 

  @Input() riskrefList :riskControlDropdownDto[]=[];
  @Input() riskAreaList :riskControlDropdownDto[]=[];
  @Input() riskCategoryList:riskControlDropdownDto[]=[];
  @Input() riskTitleList:riskControlDropdownDto[]=[];
  @Input() complianceTopicList:riskControlDropdownDto[]=[];
  @Input() entitiesImpactedList:riskControlDropdownDto[]=[];
  @Input() riskOwnerList:riskControlDropdownDto[]=[];
  @Input() riskDescriptionList:riskControlDropdownDto[]=[];
  @Input() applicableRulesList:riskControlDropdownDto[]=[];
  @Input() inherentRiskRatingList:riskControlDropdownDto[]=[];
  @Input() residualRiskRatingList:riskControlDropdownDto[]=[];
  entitieImpactedDD: string[] = [];
 
  inherentRating:string='';
 @Input() riskfilterRef!: riskControlDropdownDto[];
 @Input() riskfilterArea!: riskControlDropdownDto[];
 @Input() riskfilterCategory!: riskControlDropdownDto[];
 @Input() riskfilterTitle!: riskControlDropdownDto[];
 @Input() sidebarVisible: boolean = false;
 @Input() compliancefilterTopic!: riskControlDropdownDto[];
 @Input() entitiesfilterImpacted!: riskControlDropdownDto[];
 @Input() riskfilterOwner!: riskControlDropdownDto[];
 @Input() riskfilterDescription!: riskControlDropdownDto[];
 @Input() applicablefilterRules!: riskControlDropdownDto[];
 @Input() inherentfilterRiskRatingList:riskControlDropdownDto[]=[];
 @Input() residualfilterRiskRatingList:riskControlDropdownDto[]=[];

  @Output() filterRiskItem: EventEmitter<any> = new EventEmitter<any>();
  constructor(private formBuilder: FormBuilder) {}
  ngOnInit() {
    
    this.inherentRating;
    this.compliancefilterTopic;
    this.inherentfilterRiskRatingList;
    this.riskfilterCategory;
    this.searchedriskrefList = this.riskrefList
    this.searchedriskOwnerList= this.riskOwnerList;
    this.searchedriskAreaList =  this.riskAreaList;
    this.searchedriskTitleList = this.riskTitleList
    this.searchedriskCategoryList = this.riskCategoryList;
    this.searchedriskDescriptionList =  this.riskDescriptionList;
    this.searchedcomplianceTopicList = this.complianceTopicList;
    this.searchedentitiesImpactedList =  this.entitiesImpactedList;
    this.searchedapplicableRulesList =  this.applicableRulesList;
  this.searchedinherentRiskRatingList = this.inherentRiskRatingList;
  this.searchedresidualRiskRatingList = this.residualRiskRatingList;
    this.startFilterDropdownFieldFn();
    this.initForm();
  }
  startFilterDropdownFieldFn() {
    this.searchapplicableRulesCntrl.valueChanges.subscribe((term: any) => {
      this.searchedapplicableRulesList = term
        ? this.filterapplicableRules(term)
        : this.searchedapplicableRulesList;
    });
    this.searchriskrefCntrl.valueChanges.subscribe((term: any) => {
      this.searchedriskrefList = term
        ? this.filterriskRef(term)
        : this.searchedriskrefList;
    });
    this.searchriskOwnerCntrl.valueChanges.subscribe((term: any) => {
      this.searchedriskOwnerList = term
        ? this.filterriskOwner(term)
        : this.searchedriskOwnerList;
    });
    this.searchriskAreaCntrl.valueChanges.subscribe((term: any) => {
      this.searchedriskAreaList = term ? this.filterriskArea(term) : this.searchedriskAreaList;
    });
    this.searchriskDescriptionCntrl.valueChanges.subscribe((term: any) => {
      this.searchedriskDescriptionList = term ? this.filterriskDescription(term) : this.searchedriskDescriptionList;
    });
    this.searchriskTitleCntrl.valueChanges.subscribe((term: any) => {
      this.searchedriskTitleList = term ? this.filterriskTitle(term) : this.searchedriskTitleList;
    });
    this.searchriskCategoryCntrl.valueChanges.subscribe((term: any) => {
      this.searchedriskCategoryList = term ? this.filterriskCategory(term) : this.searchedriskCategoryList;
    });
    this.searchcomplianceTopicCntrl.valueChanges.subscribe((term: any) => {
      this.searchedcomplianceTopicList = term ? this.filtercomplianceTopic(term) : this.searchedcomplianceTopicList;
    });
    this.searchentitiesImpactedCntrl.valueChanges.subscribe((term: any) => {
      this.searchedentitiesImpactedList = term ? this.filterentitiesImpacted(term) : this.searchedentitiesImpactedList;
    });
    this.saerchinherentRiskRatingCntrl.valueChanges.subscribe((term: any) => {
      this.searchedinherentRiskRatingList = term ? this.filterinherentRiskRating(term) : this.searchedinherentRiskRatingList;
    });
    this.searchresidualRiskRatingCntrl.valueChanges.subscribe((term: any) => {
      this.searchedinherentRiskRatingList = term ? this.filterresidualRiskRating(term) : this.searchedresidualRiskRatingList;
    });
  }
  filterriskRef(search: string) {
    return this.searchedriskrefList.filter((option) =>
      option.item.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterriskArea(search: string) {
    
    return this.searchedriskAreaList.filter((option) =>
      option.item.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterriskCategory(search: string) {
    return this.searchedriskCategoryList.filter((option) =>
      option.item.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterriskTitle(search: string) {
    return this.searchedriskTitleList.filter((option) =>
      option.item.toLowerCase().includes(search.toLowerCase())
    );
  }
  filtercomplianceTopic(search: string) {
    return this.searchedcomplianceTopicList.filter((option) =>
      option.item.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterentitiesImpacted(search: string) {
    return this.searchedentitiesImpactedList.filter((option) =>
      option.item.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterinherentRiskRating(search: string) {
    return this.searchedinherentRiskRatingList.filter((option) =>
      option.item.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterresidualRiskRating(search: string) {
    return this.searchedresidualRiskRatingList.filter((option) =>
      option.item.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterriskOwner(search: string) {
    return this.searchedriskOwnerList.filter((option) =>
      option.item.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterriskDescription(search: string) {
    return this.searchedriskDescriptionList.filter((option) =>
      option.item.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterapplicableRules(search: string) {
    return this.searchedapplicableRulesList.filter((option) =>
      option.item.toLowerCase().includes(search.toLowerCase())
    );
  }

  initForm() {
    this.filterForm = this.formBuilder.group({
      riskRef: [''],
      riskArea: [''],
      riskCategory: [''],
      riskTitle: [''],
      complianceTopic: [''],
      entitiesImpacted: [''],
      riskOwner: [''],
      riskDescription: [''],
      applicableRules: [''],
      inherentRiskRating: [''],
      residualRiskRating: [''],
    });
  }

  removeriskRef(id: string) {
    if (this.riskfilterRef && this.riskfilterRef.length > 0) {
      const index = this.riskfilterRef.findIndex(
        (obj: riskControlDropdownDto) => obj.id == id
      );
      if (index >= 0) {
        this.riskfilterRef.splice(index, 1);
      }
      this.filterriskRefWithoutSelectedItem();
    }
  }
  removeriskArea(id: string) {
    if (this.riskfilterArea && this.riskfilterArea.length > 0) {
      const index = this.riskfilterArea.findIndex(
        (obj: riskControlDropdownDto) => obj.id == id
      );
      if (index >= 0) {
        this.riskfilterArea.splice(index, 1);
      }
      this.filterriskAreaWithoutSelectedItem();
    }
  }
  removeriskCategory(id: string) {
    if (this.riskfilterCategory && this.riskfilterCategory.length > 0) {
      const index = this.riskfilterCategory.findIndex(
        (obj: riskControlDropdownDto) => obj.id == id
      );
      if (index >= 0) {
        this.riskfilterCategory.splice(index, 1);
      }
      this.filterriskCategoryWithoutSelectedItem();
    }
  }
  removeriskTitle(id: string) {
    if (this.riskfilterTitle && this.riskfilterTitle.length > 0) {
      const index = this.riskfilterTitle.findIndex(
        (obj: riskControlDropdownDto) => obj.id == id
      );
      if (index >= 0) {
        this.riskfilterTitle.splice(index, 1);
      }
      this.filterriskTitleWithoutSelectedItem();
    }
  }
  removecomplianceTopic(id: string) {
    if (this.compliancefilterTopic && this.compliancefilterTopic.length > 0) {
      const index = this.compliancefilterTopic.findIndex(
        (obj: riskControlDropdownDto) => obj.id == id
      );
      if (index >= 0) {
        this.compliancefilterTopic.splice(index, 1);
      }
      this.filtercomplianceTopicWithoutSelectedItem();
    }
  }
  removeentitiesImpacted(id: string) {
    if (this.entitiesfilterImpacted && this.entitiesfilterImpacted.length > 0) {
      const index = this.entitiesfilterImpacted.findIndex(
        (obj: riskControlDropdownDto) => obj.id == id
      );
      if (index >= 0) {
        this.entitiesfilterImpacted.splice(index, 1);
      }
      this.filterentitiesImpactedWithoutSelectedItem();
    }
  }
  removeriskOwner(id: string) {
    if (this.riskfilterOwner && this.riskfilterOwner.length > 0) {
      const index = this.riskfilterOwner.findIndex(
        (obj: riskControlDropdownDto) => obj.id == id
      );
      if (index >= 0) {
        this.riskfilterOwner.splice(index, 1);
      }
      this.filterriskOwnerWithoutSelectedItem();
    }
  }
  removeriskDescription(id: string) {
    if (this.riskfilterDescription && this.riskfilterDescription.length > 0) {
      const index = this.riskfilterDescription.findIndex(
        (obj: riskControlDropdownDto) => obj.id == id
      );
      if (index >= 0) {
        this.riskfilterDescription.splice(index, 1);
      }
      this.filterriskDescriptionWithoutSelectedItem();
    }
  }
  removeapplicableRules(id: string) {
    if (this.applicablefilterRules && this.applicablefilterRules.length > 0) {
      const index = this.applicablefilterRules.findIndex(
        (obj: riskControlDropdownDto) => obj.id == id
      );
      if (index >= 0) {
        this.applicablefilterRules.splice(index, 1);
      }
      this.filterapplicableRulesWithoutSelectedItem();
    }
  }
  removeinherentRiskRating(id: string) {
    if (this.inherentfilterRiskRatingList && this.inherentfilterRiskRatingList.length > 0) {
      const index = this.inherentfilterRiskRatingList.findIndex(
        (obj: riskControlDropdownDto) => obj.id == id
      );
      if (index >= 0) {
        this.inherentfilterRiskRatingList.splice(index, 1);
      }
      this.filterinherentRiskRatingWithoutSelectedItem();
    }
  }
  removeresidualRiskRating(id: string) {
    if (this.residualfilterRiskRatingList && this.residualfilterRiskRatingList.length > 0) {
      const index = this.residualfilterRiskRatingList.findIndex(
        (obj: riskControlDropdownDto) => obj.id == id
      );
      if (index >= 0) {
        this.residualfilterRiskRatingList.splice(index, 1);
      }
      this.filterresidualRiskRatingWithoutSelectedItem();
    }
  }

  filterriskRefWithoutSelectedItem() {
    if (this.riskfilterRef && this.riskfilterRef.length > 0) {
      this.searchedriskrefList = this.riskrefList.filter(
        (obj: riskControlDropdownDto) =>
          !this.riskfilterRef.includes(obj)
      );
    } else {
      this.searchedriskrefList = this.riskrefList;
    }
  }
  filterriskAreaWithoutSelectedItem() {
    if (this.riskfilterArea && this.riskfilterArea.length > 0) {
      this.searchedriskAreaList = this.riskAreaList.filter(
        (obj: riskControlDropdownDto) =>
          !this.riskfilterArea.includes(obj)
      );
    } else {
      this.searchedriskAreaList = this.riskAreaList;
    }
  }
  filterriskCategoryWithoutSelectedItem() {
    if (this.riskfilterCategory && this.riskfilterCategory.length > 0) {
      this.searchedriskCategoryList = this.riskCategoryList.filter(
        (obj: riskControlDropdownDto) =>
          !this.riskfilterCategory.includes(obj)
      );
    } else {
      this.searchedriskCategoryList = this.riskCategoryList;
    }
  }
  filterriskTitleWithoutSelectedItem() {
    if (this.riskfilterTitle && this.riskfilterTitle.length > 0) {
      this.searchedriskTitleList = this.riskTitleList.filter(
        (obj: riskControlDropdownDto) =>
          !this.riskfilterTitle.includes(obj)
      );
    } else {
      this.searchedriskTitleList = this.riskTitleList;
    }
  }
  filtercomplianceTopicWithoutSelectedItem() {
    if (this.compliancefilterTopic && this.compliancefilterTopic.length > 0) {
      this.searchedcomplianceTopicList = this.complianceTopicList.filter(
        (obj: riskControlDropdownDto) =>
          !this.compliancefilterTopic.includes(obj)
      );
    } else {
      this.searchedcomplianceTopicList = this.complianceTopicList;
    }
  }
  filterentitiesImpactedWithoutSelectedItem() {
    if (this.entitiesfilterImpacted && this.entitiesfilterImpacted.length > 0) {
      this.searchedentitiesImpactedList = this.entitiesImpactedList.filter(
        (obj: riskControlDropdownDto) =>
          !this.entitiesfilterImpacted.includes(obj)
      );
    } else {
      this.searchedentitiesImpactedList = this.entitiesImpactedList;
    }
  }
  filterriskOwnerWithoutSelectedItem() {
    if (this.riskfilterOwner && this.riskfilterOwner.length > 0) {
      this.searchedriskOwnerList = this.riskOwnerList.filter(
        (obj: riskControlDropdownDto) =>
          !this.riskfilterOwner.includes(obj)
      );
    } else {
      this.searchedriskOwnerList = this.riskOwnerList;
    }
  }
  filterriskDescriptionWithoutSelectedItem() {
    if (this.riskfilterDescription && this.riskfilterDescription.length > 0) {
      this.searchedriskDescriptionList = this.riskDescriptionList.filter(
        (obj: riskControlDropdownDto) =>
          !this.riskfilterDescription.includes(obj)
      );
    } else {
      this.searchedriskDescriptionList = this.riskOwnerList;
    }
  }
  filterapplicableRulesWithoutSelectedItem() {
    if (this.applicablefilterRules && this.applicablefilterRules.length > 0) {
      this.searchedapplicableRulesList = this.applicableRulesList.filter(
        (obj: riskControlDropdownDto) =>
          !this.applicablefilterRules.includes(obj)
      );
    } else {
      this.searchedapplicableRulesList = this.applicableRulesList;
    }
  }
  filterinherentRiskRatingWithoutSelectedItem() {
    if (this.inherentfilterRiskRatingList && this.inherentfilterRiskRatingList.length > 0) {
      this.searchedinherentRiskRatingList = this.inherentRiskRatingList.filter(
        (obj: riskControlDropdownDto) =>
          !this.inherentfilterRiskRatingList.includes(obj)
      );
    } else {
      this.searchedinherentRiskRatingList = this.inherentRiskRatingList;
    }
  }
  filterresidualRiskRatingWithoutSelectedItem() {
    if (this.residualfilterRiskRatingList && this.residualfilterRiskRatingList.length > 0) {
      this.searchedresidualRiskRatingList = this.residualRiskRatingList.filter(
        (obj: riskControlDropdownDto) =>
          !this.residualfilterRiskRatingList.includes(obj)
      );
    } else {
      this.searchedresidualRiskRatingList = this.residualRiskRatingList;
    }
  }
 
  addriskRef(event: MatChipInputEvent) {
    const value = event.value;
    if (!this.riskRefAutoComplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.riskfilterRef?.find(
          (option: riskControlDropdownDto) => option.item == value
        );
        if (!sameValueRow) {
          this.riskfilterRef =
            this.riskfilterRef && this.riskfilterRef.length > 0
              ? this.riskfilterRef
              : [];
          this.riskfilterRef.push({
            id: '0',
            item: value,
            icon: '',
          });
        }
      }
      this.filterriskRefWithoutSelectedItem();
      event.chipInput!.clear();
      this.searchriskrefCntrl.setValue(null);
    }
  }

  addriskArea(event: MatChipInputEvent) {
    const value = event.value;
    if (!this.riskAreaAutoComplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.riskfilterArea?.find(
          (option: riskControlDropdownDto) => option.item == value
        );
        if (!sameValueRow) {
          this.riskfilterArea =
            this.riskfilterArea && this.riskfilterArea.length > 0
              ? this.riskfilterArea
              : [];
          this.riskfilterArea.push({
            id: '0',
            item: value,
            icon: '',
          });
        }
      }
      this.filterriskAreaWithoutSelectedItem();
      event.chipInput!.clear();
      this.searchriskAreaCntrl.setValue(null);
    }
  }
  addriskCategory(event: MatChipInputEvent) {
    const value = event.value;
    if (!this.riskCategoryAutoComplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.riskfilterCategory?.find(
          (option: riskControlDropdownDto) => option.item == value
        );
        if (!sameValueRow) {
          this.riskfilterCategory =
            this.riskfilterCategory && this.riskfilterCategory.length > 0
              ? this.riskfilterCategory
              : [];
          this.riskfilterCategory.push({
            id: '0',
            item: value,
            icon: '',
          });
        }
      }
      this.filterriskCategoryWithoutSelectedItem();
      event.chipInput!.clear();
      this.searchriskCategoryCntrl.setValue(null);
    }
  }
  addriskTitle(event: MatChipInputEvent) {
    const value = event.value;
    if (!this.riskTitleAutoComplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.riskfilterTitle?.find(
          (option: riskControlDropdownDto) => option.item == value
        );
        if (!sameValueRow) {
          this.riskfilterTitle =
            this.riskfilterTitle && this.riskfilterTitle.length > 0
              ? this.riskfilterTitle
              : [];
          this.riskfilterTitle.push({
            id: '0',
            item: value,
            icon: '',
          });
        }
      }
      this.filterriskTitleWithoutSelectedItem();
      event.chipInput!.clear();
      this.searchriskTitleCntrl.setValue(null);
    }
  }
  addcomplianceTopic(event: MatChipInputEvent) {
    const value = event.value;
    if (!this.complianceTopicAutoComplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.compliancefilterTopic?.find(
          (option: riskControlDropdownDto) => option.item == value
        );
        if (!sameValueRow) {
          this.compliancefilterTopic =
            this.compliancefilterTopic && this.compliancefilterTopic.length > 0
              ? this.compliancefilterTopic
              : [];
          this.compliancefilterTopic.push({
            id: '0',
            item: value,
            icon: '',
          });
        }
      }
      this.filtercomplianceTopicWithoutSelectedItem();
      event.chipInput!.clear();
      this.searchcomplianceTopicCntrl.setValue(null);
    }
  }
  addentitiesImpacted(event: MatChipInputEvent) {
    const value = event.value;
    if (!this.entitiesImpactedAutoComplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.entitiesfilterImpacted?.find(
          (option: riskControlDropdownDto) => option.item == value
        );
        if (!sameValueRow) {
          this.entitiesfilterImpacted =
            this.entitiesfilterImpacted && this.entitiesfilterImpacted.length > 0
              ? this.entitiesfilterImpacted
              : [];
          this.entitiesfilterImpacted.push({
            id: '0',
            item: value,
            icon: '',
          });
        }
      }
      this.filterentitiesImpactedWithoutSelectedItem();
      event.chipInput!.clear();
      this.searchentitiesImpactedCntrl.setValue(null);
    }
  }
  
  addriskOwner(event: MatChipInputEvent) {
    const value = event.value;
    if (!this.riskOwnerAutoComplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.riskfilterOwner?.find(
          (option: riskControlDropdownDto) => option.item == value
        );
        if (!sameValueRow) {
          this.riskfilterOwner =
            this.riskfilterOwner && this.riskfilterOwner.length > 0
              ? this.riskfilterOwner
              : [];
          this.riskfilterOwner.push({
            id: '0',
            item: value,
            icon: '',
          });
        }
      }
      this.filterriskOwnerWithoutSelectedItem();
      event.chipInput!.clear();
      this.searchriskOwnerCntrl.setValue(null);
    }
  }
  addriskDescription(event: MatChipInputEvent) {
    const value = event.value;
    if (!this.riskDescriptionAutoComplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.riskfilterDescription?.find(
          (option: riskControlDropdownDto) => option.item == value
        );
        if (!sameValueRow) {
          this.riskfilterDescription =
            this.riskfilterDescription && this.riskfilterDescription.length > 0
              ? this.riskfilterDescription
              : [];
          this.riskfilterDescription.push({
            id: '0',
            item: value,
            icon: '',
          });
        }
      }
      this.filterriskDescriptionWithoutSelectedItem();
      event.chipInput!.clear();
      this.searchriskDescriptionCntrl.setValue(null);
    }
  }
  addapplicableRules(event: MatChipInputEvent) {
    const value = event.value;
    if (!this.applicableRulesAutoComplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.applicablefilterRules?.find(
          (option: riskControlDropdownDto) => option.item == value
        );
        if (!sameValueRow) {
          this.applicablefilterRules =
            this.applicablefilterRules && this.applicablefilterRules.length > 0
              ? this.applicablefilterRules
              : [];
         
          this.applicablefilterRules.push({
            id: '0',
            item: value,
          });
        }
      }
      this.filterapplicableRulesWithoutSelectedItem();
      event.chipInput!.clear();
      this.searchapplicableRulesCntrl.setValue(null);
    }
  }
  addinherentRiskRating(event: MatChipInputEvent) {
    const value = event.value;
    if (!this.inherentRiskRatingAutoComplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.inherentfilterRiskRatingList?.find(
          (option: riskControlDropdownDto) => option.item == value
        );
        if (!sameValueRow) {
          this.inherentfilterRiskRatingList =
            this.inherentfilterRiskRatingList && this.inherentfilterRiskRatingList.length > 0
              ? this.inherentfilterRiskRatingList
              : [];
         
          this.inherentfilterRiskRatingList.push({
            id: '0',
            item: value,
          });
        }
      }
      this.filterinherentRiskRatingWithoutSelectedItem();
      event.chipInput!.clear();
      this.saerchinherentRiskRatingCntrl.setValue(null);
    }
  }
  addresidualRiskRating(event: MatChipInputEvent) {
    const value = event.value;
    if (!this.residualRiskRatingAutoComplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.residualfilterRiskRatingList?.find(
          (option: riskControlDropdownDto) => option.item == value
        );
        if (!sameValueRow) {
          this.residualfilterRiskRatingList =
            this.residualfilterRiskRatingList && this.residualfilterRiskRatingList.length > 0
              ? this.residualfilterRiskRatingList
              : [];
         
          this.residualfilterRiskRatingList.push({
            id: '0',
            item: value,
          });
        }
      }
      this.filterresidualRiskRatingWithoutSelectedItem();
      event.chipInput!.clear();
      this.searchresidualRiskRatingCntrl.setValue(null);
    }
  }


  selectedriskRefEvent(event: MatAutocompleteSelectedEvent) {
    
    if (this.riskfilterRef) {
      let sameValueRow = this.riskfilterRef.filter(
        (option: riskControlDropdownDto) =>
          option.item == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.addriskRefFilterListFn(event.option.viewValue);
      }
    } else {
      this.riskfilterRef = [];
      this.addriskRefFilterListFn(event.option.viewValue);
    }
    if (this.riskRefInput) {
      this.riskRefInput.nativeElement.value = '';
    }
    this.searchriskrefCntrl.setValue(null);
    this.searchriskrefCntrl.disable();
    this.searchriskrefCntrl.enable();
    this.filterriskRefWithoutSelectedItem();
  }
  selectedriskAreaEvent(event: MatAutocompleteSelectedEvent) {
    
    if (this.riskfilterArea) {
      let sameValueRow = this.riskfilterArea.filter(
        (option: riskControlDropdownDto) =>
          option.item == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.addriskAreaFilterListFn(event.option.viewValue);
      }
    } else {
      this.riskfilterArea = [];
      this.addriskAreaFilterListFn(event.option.viewValue);
    }
    if (this.riskAreaInput) {
      this.riskAreaInput.nativeElement.value = '';
    }
    this.searchriskAreaCntrl.setValue(null);
    this.searchriskAreaCntrl.disable();
    this.searchriskAreaCntrl.enable();
    this.filterriskAreaWithoutSelectedItem();
  }
  selectedriskCategoryEvent(event: MatAutocompleteSelectedEvent) {
    if (this.riskfilterCategory) {
      let sameValueRow = this.riskfilterCategory.filter(
        (option: riskControlDropdownDto) =>
          option.item == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.addriskCategoryFilterListFn(event.option.viewValue);
      }
    } else {
      this.riskfilterCategory = [];
      this.addriskCategoryFilterListFn(event.option.viewValue);
    }
    if (this.riskCategoryInput) {
      this.riskCategoryInput.nativeElement.value = '';
    }
    this.searchriskCategoryCntrl.setValue(null);
    this.searchriskCategoryCntrl.disable();
    this.searchriskCategoryCntrl.enable();
    this.filterriskCategoryWithoutSelectedItem();
  }
  selectedriskTitleEvent(event: MatAutocompleteSelectedEvent) {
    if (this.riskfilterTitle) {
      let sameValueRow = this.riskfilterTitle.filter(
        (option: riskControlDropdownDto) =>
          option.item == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.addriskTitleFilterListFn(event.option.viewValue);
      }
    } else {
      this.riskfilterTitle = [];
      this.addriskTitleFilterListFn(event.option.viewValue);
    }
    if (this.riskTitleInput) {
      this.riskTitleInput.nativeElement.value = '';
    }
    this.searchriskTitleCntrl.setValue(null);
    this.searchriskTitleCntrl.disable();
    this.searchriskTitleCntrl.enable();
    this.filterriskTitleWithoutSelectedItem();
  }
  selectedcomplianceTopicEvent(event: MatAutocompleteSelectedEvent) {
    if (this.compliancefilterTopic) {
      let sameValueRow = this.compliancefilterTopic.filter(
        (option: riskControlDropdownDto) =>
          option.item == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.addcomplianceTopicFilterListFn(event.option.viewValue);
      }
    } else {
      this.compliancefilterTopic = [];
      this.addcomplianceTopicFilterListFn(event.option.viewValue);
    }
    if (this.complianceTopicInput) {
      this.complianceTopicInput.nativeElement.value = '';
    }
    this.searchcomplianceTopicCntrl.setValue(null);
    this.searchcomplianceTopicCntrl.disable();
    this.searchcomplianceTopicCntrl.enable();
    this.filtercomplianceTopicWithoutSelectedItem();
  }
  selectedentitiesImpactedEvent(event: MatAutocompleteSelectedEvent) {
    if (this.entitiesfilterImpacted) {
      let sameValueRow = this.entitiesfilterImpacted.filter(
        (option: riskControlDropdownDto) =>
          option.item == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.addentitiesImpactedFilterListFn(event.option.viewValue);
      }
    } else {
      this.entitiesfilterImpacted = [];
      this.addentitiesImpactedFilterListFn(event.option.viewValue);
    }
    if (this.entitiesImpactedInput) {
      this.entitiesImpactedInput.nativeElement.value = '';
    }
    this.searchentitiesImpactedCntrl.setValue(null);
    this.searchentitiesImpactedCntrl.disable();
    this.searchentitiesImpactedCntrl.enable();
    this.filterentitiesImpactedWithoutSelectedItem();
  }
  selectedriskOwnerEvent(event: MatAutocompleteSelectedEvent) {
    if (this.riskfilterOwner) {
      let sameValueRow = this.riskfilterOwner.filter(
        (option: riskControlDropdownDto) =>
          option.item == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.addriskOwnerFilterListFn(event.option.viewValue);
      }
    } else {
      this.riskfilterOwner = [];
      this.addriskOwnerFilterListFn(event.option.viewValue);
    }
    if (this.riskOwnerInput) {
      this.riskOwnerInput.nativeElement.value = '';
    }
    this.searchriskOwnerCntrl.setValue(null);
    this.searchriskOwnerCntrl.disable();
    this.searchriskOwnerCntrl.enable();
    this.filterriskOwnerWithoutSelectedItem();
  }
  selectedriskDescriptionEvent(event: MatAutocompleteSelectedEvent) {
    if (this.riskfilterDescription) {
      let sameValueRow = this.riskfilterDescription.filter(
        (option: riskControlDropdownDto) =>
          option.item == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.addriskDescriptionFilterListFn(event.option.viewValue);
      }
    } else {
      this.riskfilterDescription = [];
      this.addriskDescriptionFilterListFn(event.option.viewValue);
    }
    if (this.riskDescriptionInput) {
      this.riskDescriptionInput.nativeElement.value = '';
    }
    this.searchriskDescriptionCntrl.setValue(null);
    this.searchriskDescriptionCntrl.disable();
    this.searchriskDescriptionCntrl.enable();
    this.filterriskDescriptionWithoutSelectedItem();
  }
  selectedapplicableRulesnEvent(event: MatAutocompleteSelectedEvent) {
    if (this.applicablefilterRules) {
      let sameValueRow = this.applicablefilterRules.filter(
        (option: riskControlDropdownDto) =>
          option.item == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.addapplicableRulesFilterListFn(event.option.viewValue);
      }
    } else {
      this.applicablefilterRules = [];
      this.addapplicableRulesFilterListFn(event.option.viewValue);
    }
    if (this.applicableRulesInput) {
      this.applicableRulesInput.nativeElement.value = '';
    }
    this.searchapplicableRulesCntrl.setValue(null);
    this.searchapplicableRulesCntrl.disable();
    this.searchapplicableRulesCntrl.enable();
    this.filterapplicableRulesWithoutSelectedItem();
  }
  selectedinherentRiskRatingEvent(event: MatAutocompleteSelectedEvent) {
    if (this.inherentfilterRiskRatingList) {
      let sameValueRow = this.inherentfilterRiskRatingList.filter(
        (option: riskControlDropdownDto) =>
          option.item == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.addinherentRiskRatingFilterListFn(event.option.viewValue);
      }
    } else {
      this.inherentfilterRiskRatingList = [];
      this.addinherentRiskRatingFilterListFn(event.option.viewValue);
    }
    if (this.inherentRiskRatingInput) {
      this.inherentRiskRatingInput.nativeElement.value = '';
    }
    this.saerchinherentRiskRatingCntrl.setValue(null);
    this.saerchinherentRiskRatingCntrl.disable();
    this.saerchinherentRiskRatingCntrl.enable();
    this.filterinherentRiskRatingWithoutSelectedItem();
  }
  selectedresidualRiskRatingEvent(event: MatAutocompleteSelectedEvent) {
    if (this.residualfilterRiskRatingList) {
      let sameValueRow = this.residualfilterRiskRatingList.filter(
        (option: riskControlDropdownDto) =>
          option.item == event.option.viewValue
      );
      if (sameValueRow.length == 0) {
        this.addresidualRiskRatingFilterListFn(event.option.viewValue);
      }
    } else {
      this.residualfilterRiskRatingList = [];
      this.addresidualRiskRatingFilterListFn(event.option.viewValue);
    }
    if (this.residualRiskRatingInput) {
      this.residualRiskRatingInput.nativeElement.value = '';
    }
    this.searchresidualRiskRatingCntrl.setValue(null);
    this.searchresidualRiskRatingCntrl.disable();
    this.searchresidualRiskRatingCntrl.enable();
    this.filterresidualRiskRatingWithoutSelectedItem();
  }
 
  addriskRefFilterListFn(matchString: string) {
    let selectedValue: riskControlDropdownDto | undefined =
      this.riskrefList.find((option) => option.item == matchString);
    if (selectedValue) {
      this.riskfilterRef.push(selectedValue);
    }
  }
  addriskAreaFilterListFn(matchString: string) {
    
    let selectedValue: riskControlDropdownDto | undefined =
      this.riskAreaList.find((option) => option.item == matchString);
    if (selectedValue) {
      this.riskfilterArea.push(selectedValue);
    }
  }
  addriskCategoryFilterListFn(matchString: string) {
    let selectedValue: riskControlDropdownDto | undefined =
      this.riskCategoryList.find((option) => option.item == matchString);
    if (selectedValue) {
      this.riskfilterCategory.push(selectedValue);
    }
  }
  addriskTitleFilterListFn(matchString: string) {
    let selectedValue: riskControlDropdownDto | undefined =
      this.riskTitleList.find((option) => option.item == matchString);
    if (selectedValue) {
      this.riskfilterTitle.push(selectedValue);
    }
  }
  addcomplianceTopicFilterListFn(matchString: string) {
    let selectedValue: riskControlDropdownDto | undefined =
      this.complianceTopicList.find((option) => option.item == matchString);
    if (selectedValue) {
      this.compliancefilterTopic.push(selectedValue);
    }
  }
  addentitiesImpactedFilterListFn(matchString: string) {
    let selectedValue: riskControlDropdownDto | undefined =
      this.entitiesImpactedList.find((option) => option.item == matchString);
    if (selectedValue) {
      this.entitiesfilterImpacted.push(selectedValue);
    }
  }
  addriskOwnerFilterListFn(matchString: string) {
    let selectedValue: riskControlDropdownDto | undefined =
      this.riskOwnerList.find((option) => option.item == matchString);
    if (selectedValue) {
      this.riskfilterOwner.push(selectedValue);
    }
  }
  addriskDescriptionFilterListFn(matchString: string) {
    let selectedValue: riskControlDropdownDto | undefined =
      this.riskDescriptionList.find((option) => option.item == matchString);
    if (selectedValue) {
      this.riskfilterDescription.push(selectedValue);
    }
  }
  addapplicableRulesFilterListFn(matchString: string) {
    let selectedValue: riskControlDropdownDto | undefined =
      this.applicableRulesList.find((option) => option.item == matchString);
    if (selectedValue) {
      this.applicablefilterRules.push(selectedValue);
    }
  }
  addinherentRiskRatingFilterListFn(matchString: string) {
    let selectedValue: riskControlDropdownDto | undefined =
      this.inherentRiskRatingList.find((option) => option.item == matchString);
    if (selectedValue) {
      this.inherentfilterRiskRatingList.push(selectedValue);
    }
  }
  addresidualRiskRatingFilterListFn(matchString: string) {
    let selectedValue: riskControlDropdownDto | undefined =
      this.residualRiskRatingList.find((option) => option.item == matchString);
    if (selectedValue) {
      this.residualfilterRiskRatingList.push(selectedValue);
    }
  }
  onInheretRating(event:any){
    
    this.inherentRating = event.value;
  }
  saveFilters() {
    
this.filterForm.value.inherentRiskRating = this.inherentRating;
    if (this.riskfilterRef && this.riskfilterRef.length > 0) {
      let riskrefList = this.riskfilterRef.map((obj) => obj.item);
      if (riskrefList) {
        this.filterForm.value.riskRef = riskrefList;
      }
    } else {
      this.filterForm.value.riskRef = [];
    }
    if (this.riskfilterArea && this.riskfilterArea.length > 0) {
      let riskareaList = this.riskfilterArea.map((obj) => obj.item);
      if (riskareaList) {
        this.filterForm.value.riskArea = riskareaList;
      }
    } else {
      this.filterForm.value.riskArea = [];
    }
    if (this.riskfilterCategory && this.riskfilterCategory.length > 0) {
      let riskcategoryList = this.riskfilterCategory.map((obj) => obj.item);
      if (riskcategoryList) {
        this.filterForm.value.riskCategory = riskcategoryList;
      }
    } else {
      this.filterForm.value.riskCategory = [];
    }
    if (this.riskfilterTitle && this.riskfilterTitle.length > 0) {
      let risktitleList = this.riskfilterTitle.map((obj) => obj.item);
      if (risktitleList) {
        this.filterForm.value.riskTitle = risktitleList;
      }
    } else {
      this.filterForm.value.riskTitle = [];
    }

    if (this.compliancefilterTopic && this.compliancefilterTopic.length > 0) {
      let complancelist = this.compliancefilterTopic.map((obj) => obj.item);
      if (complancelist) {
        this.filterForm.value.complianceTopic = complancelist;
      }
    } else {
      this.filterForm.value.complianceTopic = [];
    }
    
    if (this.entitiesfilterImpacted && this.entitiesfilterImpacted.length > 0) {
      let entitiedimpacted = this.entitiesfilterImpacted.map((obj) => obj.item);
      if (entitiedimpacted) {
        this.filterForm.value.entitiesImpacted = entitiedimpacted;
      }
    } else {
      this.filterForm.value.entitiedimpacted = [];
    }
    if (this.riskfilterOwner && this.riskfilterOwner.length > 0) {
      let riskowner = this.riskfilterOwner.map((obj) => obj.item);
      if (riskowner) {
        this.filterForm.value.riskOwner = riskowner;
      }
    } else {
      this.filterForm.value.riskOwner = [];
    }
    if (this.riskfilterDescription && this.riskfilterDescription.length > 0) {
      let riskdescription = this.riskfilterDescription.map((obj) => obj.item);
      if (riskdescription) {
        this.filterForm.value.riskDescription = riskdescription;
      }
    } else {
      this.filterForm.value.riskDescription = [];
    }
    if (this.applicablefilterRules && this.applicablefilterRules.length > 0) {
      let applicablesrules = this.applicablefilterRules.map((obj) => obj.item);
      if (applicablesrules) {
        this.filterForm.value.applicableRules = applicablesrules;
      }
    } else {
      this.filterForm.value.applicableRules = [];
    }
    if (this.inherentfilterRiskRatingList && this.inherentfilterRiskRatingList.length > 0) {
      let inherentRiskRating = this.inherentfilterRiskRatingList.map((obj) => obj.item);
      if (inherentRiskRating) {
        this.filterForm.value.inherentRiskRating = inherentRiskRating;
      }
    } else {
      this.filterForm.value.inherentRiskRating = [];
    }
    if (this.residualfilterRiskRatingList && this.residualfilterRiskRatingList.length > 0) {
      let residualRiskRating = this.residualfilterRiskRatingList.map((obj) => obj.item);
      if (residualRiskRating) {
        this.filterForm.value.residualRiskRating = residualRiskRating;
      }
    } else {
      this.filterForm.value.residualRiskRating = [];
    }
    
    this.filterRiskItem.emit({
      result: this.filterForm.value,
      riskRef: this.riskfilterRef,
      riskArea: this.riskfilterArea,
      riskCategory: this.riskfilterCategory,
      riskTitle: this.riskfilterTitle,
      complianceTopic: this.compliancefilterTopic,
      entitiesImpacted:this.entitiesfilterImpacted,
      riskOwner:this.riskfilterOwner,
      riskDescription:this.riskfilterDescription,
      applicableRules:this.applicablefilterRules,
     inherentRiskRatingList:this.inherentfilterRiskRatingList,
     residualRiskRatingList:this.residualfilterRiskRatingList,

    });
  }
  resetFilters() {
    
    this.riskfilterArea = [];
    this.riskfilterCategory = [];
    this.riskfilterDescription = [];
    this.riskfilterOwner = [];
    this.riskfilterRef = [];
    this.riskfilterTitle = [];
    this.compliancefilterTopic = [];
    this.entitiesfilterImpacted = [];
    this.applicablefilterRules = [];
    this.inherentfilterRiskRatingList=[];
    this.residualfilterRiskRatingList=[];
    this.filterRiskItem.emit();
  }
}

